import api from "./config";

export const authAPI = {
  signup: async (userData) => {
    try {
      const signupData = {
        username: userData.username || userData.name,
        email: userData.email,
        contact: userData.contact,
        password: userData.password,
      };

      const response = await api.post("/users/register", signupData);

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || "Signup failed",
      };
    }
  },

  login: async (credentials) => {
    try {

      // Ensure credentials are properly formatted
      if (!credentials.email || !credentials.password) {
        return {
          success: false,
          error: "Email and password are required",
        };
      }

      const response = await api.post("/auth/login", credentials);

      // Check if token is received
      if (!response.data.token) {
        return {
          success: false,
          error: "Authentication failed - no token received",
        };
      }

      localStorage.setItem("token", response.data.token);

      try {
        // Get user data with new token
        const userResponse = await api.get("/auth/user");
        localStorage.setItem("user", JSON.stringify(userResponse.data));

        return {
          success: true,
          data: {
            token: response.data.token,
            user: userResponse.data,
          },
        };
      } catch (userError) {
        // Still return success if we at least got the token
        return {
          success: true,
          data: {
            token: response.data.token,
            user: null,
          },
        };
      }
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || "Login failed",
      };
    }
  },

  logout: () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
  },

  getCurrentUser: async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        return {
          success: false,
          error: "No auth token found",
        };
      }

      const response = await api.get("/auth/user");

      if (!response.data) {
        return {
          success: false,
          error: "Failed to get user data",
        };
      }

      return {
        success: true,
        data: {
          user: response.data,
        },
      };
    } catch (error) {

      // Special handling for auth errors
      if (error.response?.status === 401) {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
      }

      return {
        success: false,
        error: error.response?.data?.message || "Failed to get current user",
      };
    }
  },
};
